<div *ngIf="typeIcon === 'icon'" class="icon" [ngClass]="[getColor(), getSize()]">
  <img *ngIf="img" [src]="'../../../../assets/svg/' + img + '.svg'" />
</div>

<div *ngIf="typeIcon == 'pictograma'" class="pictograma" [ngClass]="getSize()">
    <img *ngIf="img" [src]="'../../../../assets/svg/' + img + '.svg'" />
  </div>
